export const stateOptions = [
  { value: "AL", label: "AL" },
  { value: "AK", label: "AK" },
  { value: "AZ", label: "AZ" },
  { value: "AR", label: "AR" },
  { value: "CA", label: "CA" },
  { value: "CO", label: "CO" },
  { value: "CT", label: "CT" },
  { value: "DE", label: "DE" },
  { value: "DC", label: "DC" },
  { value: "FL", label: "FL" },
  { value: "GA", label: "GA" },
  { value: "GU", label: "GU" },
  { value: "HI", label: "HI" },
  { value: "ID", label: "ID" },
  { value: "IL", label: "IL" },
  { value: "IN", label: "IN" },
  { value: "IA", label: "IA" },
  { value: "KS", label: "KS" },
  { value: "KY", label: "KY" },
  { value: "LA", label: "LA" },
  { value: "ME", label: "ME" },
  { value: "MD", label: "MD" },
  { value: "MA", label: "MA" },
  { value: "MI", label: "MI" },
  { value: "MN", label: "MN" },
  { value: "MS", label: "MS" },
  { value: "MO", label: "MO" },
  { value: "MT", label: "MT" },
  { value: "NE", label: "NE" },
  { value: "NV", label: "NV" },
  { value: "NH", label: "NH" },
  { value: "NJ", label: "NJ" },
  { value: "NM", label: "NM" },
  { value: "NY", label: "NY" },
  { value: "NC", label: "NC" },
  { value: "ND", label: "ND" },
  { value: "OH", label: "OH" },
  { value: "OK", label: "OK" },
  { value: "OR", label: "OR" },
  { value: "PA", label: "PA" },
  { value: "PR", label: "PR" },
  { value: "RI", label: "RI" },
  { value: "SC", label: "SC" },
  { value: "SD", label: "SD" },
  { value: "TN", label: "TN" },
  { value: "TX", label: "TX" },
  { value: "UT", label: "UT" },
  { value: "VT", label: "VT" },
  { value: "VI", label: "VI" },
  { value: "VA", label: "VA" },
  { value: "WA", label: "WA" },
  { value: "WV", label: "WV" },
  { value: "WI", label: "WI" },
  { value: "WY", label: "WY" },
];
export const canadianValues = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT",
];

export const yearOption = [
  { value: "", label: "Year", disabled: true },
  { value: "2026", label: "2026" },
  { value: "2025", label: "2025" },
  { value: "2024", label: "2024" },
  { value: "2023", label: "2023" },
  { value: "2022", label: "2022" },
  { value: "2021", label: "2021" },
  { value: "2020", label: "2020" },
  { value: "2019", label: "2019" },
  { value: "2018", label: "2018" },
  { value: "2017", label: "2017" },
  { value: "2016", label: "2016" },
  { value: "2015", label: "2015" },
  { value: "2014", label: "2014" },
  { value: "2013", label: "2013" },
  { value: "2012", label: "2012" },
  { value: "2011", label: "2011" },
  { value: "2010", label: "2010" },
  { value: "2009", label: "2009" },
  { value: "2008", label: "2008" },
  { value: "2007", label: "2007" },
  { value: "2006", label: "2006" },
  { value: "2005", label: "2005" },
  { value: "2004", label: "2004" },
  { value: "2003", label: "2003" },
  { value: "2002", label: "2002" },
  { value: "2001", label: "2001" },
  { value: "2000", label: "2000" },
  { value: "1999", label: "1999" },
  { value: "1998", label: "1998" },
  { value: "1997", label: "1997" },
  { value: "1996", label: "1996" },
  { value: "1995", label: "1995" },
  { value: "1994", label: "1994" },
  { value: "1993", label: "1993" },
  { value: "1992", label: "1992" },
  { value: "1991", label: "1991" },
  { value: "1990", label: "1990" },
  { value: "1989", label: "1989" },
  { value: "1988", label: "1988" },
  { value: "1987", label: "1987" },
  { value: "1986", label: "1986" },
  { value: "1985", label: "1985" },
  { value: "1984", label: "1984" },
  { value: "1983", label: "1983" },
  { value: "1982", label: "1982" },
  { value: "1981", label: "1981" },
];
export const monthOption = [
  { value: "", label: "Month", disabled: true },
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];
export const dealerOption = [
  { value: "", label: "Choose One", disabled: true },
  { value: "DEALER", label: "Dealer" },
  { value: "PRIVATE_SELLER", label: "Private Seller" },
  { value: "OTHER", label: "Other" },
];
export const dayOption = [
  { value: "", label: "Day", disabled: true },
  { value: "01", label: "1" },
  { value: "02", label: "2" },
  { value: "03", label: "3" },
  { value: "04", label: "4" },
  { value: "05", label: "5" },
  { value: "06", label: "6" },
  { value: "07", label: "7" },
  { value: "08", label: "8" },
  { value: "09", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
  { value: "31", label: "31" },
];

export const imagesOpt = [
  {
    alt: "test1",
    imageUrl: require("../assets/images/AutoCheckVHR.png"),
  },
  {
    alt: "2",
    imageUrl: require("../assets/images/AutoCheckVHR.png"),
  },
  {
    alt: "3",
    imageUrl: require("../assets/images/AutoCheckVHR.png"),
  },
  {
    alt: "4",
    imageUrl: require("../assets/images/AutoCheckVHR.png"),
  },
];

export const recaptchaActions = {
  vinSearch: "VinSearch",
  plateSearch: "PlateSearch",
  floodRiskCheck: "FloodRiskCheck",
  recallCheck: "RecallCheck",
  loadAnalytics: "LoadAnalytics",
  login: "Login",
};

export const imageClassValues = [
  {
    types: [
      "Alt Power - Electric Car",
      "Alt Power - Hybrid Car",
      "Alt Power - Hybrid Truck",
      "Alt Power - Natural Gas",
    ],
    value: "Alt-Power",
  },
  {
    types: ["CUV - Entry Level", "CUV - Mid Range", "CUV - Premium"],
    value: "CUV",
  },
  {
    types: [
      "Mid Range Car - Lower",
      "Mid Range Car - Premium",
      "Mid Range Car - Standard",
    ],
    value: "Mid-Sized",
  },
  {
    types: ["Other"],
    value: "Other",
  },
  {
    types: ["Pickup - Full Sized", "Pickup - Small"],
    value: "Pickup",
  },
  {
    types: ["Small Car - Budget"],
    value: "Compact",
  },
  {
    types: ["Small Car - Economy"],
    value: "Subcompact",
  },
  {
    types: [
      "Sport Car - Premium",
      "Sport Car - Touring",
      "Sport Car - Ultra Luxury",
      "Sport Car - Upper Premium",
    ],
    value: "Sporty",
  },
  {
    types: [
      "SUV - Entry Level",
      "SUV - Large",
      "SUV - Lower Mid Range",
      "SUV - Pickup",
      "SUV - Premium Large",
      "SUV - Upper Mid Range",
    ],
    value: "SUV",
  },
  {
    types: ["Traditional Car"],
    value: "Mid-Sized",
  },
  {
    types: [
      "Upscale - Luxury",
      "Upscale - Near Luxury",
      "Upscale - Premium",
      "Upscale - Ultra",
    ],
    value: "Luxury",
  },
  {
    types: ["Van - Full Sized", "Van - Mini"],
    value: "Van",
  },
];
